import request from './request';
import Cookies from "js-cookie";

// 登录
export const UserLogin = (data) => {
    return request({
        url: '/User/UserLogin',
        method: 'post',
        data
    })
}

// 获取集团列表
export const GetGroupList = (params) => {
    return request({
        url: '/Basic/GetGroupList' + params,
        method: 'get',
        token: Cookies.get('Token')
    })
}

// 添加集团
export const AddGroup = (data) => {
    return request({
        url: '/Basic/AddGroup',
        method: 'post',
        data,
        token: Cookies.get('Token')
    })
}

// 修改集团信息
export const UpdateGroup = (data) => {
    return request({
        url: '/Basic/UpdateGroup',
        method: 'post',
        data,
        token: Cookies.get('Token')
    })
}

// 删除集团
export const DeleteGroup = (params) => {
    return request({
        url: '/Basic/DeleteGroup' + params,
        method: 'get',
        token: Cookies.get('Token')
    })
}

// 获取集团列表（不带分页）
export const GetGrouplists = (params) => {
    return request({
        url: '/Basic/GetGrouplists',
        method: 'get',
        token: Cookies.get('Token')
    })
}

// 获取公司列表
export const GetCompanyList = (params) => {
    return request({
        url: '/Basic/GetCompanyList' + params,
        method: 'get',
        token: Cookies.get('Token')
    })
}

// 添加公司
export const AddCompany = (data) => {
    return request({
        url: '/Basic/AddCompany',
        method: 'post',
        data,
        token: Cookies.get('Token')
    })
}

// 修改公司信息
export const UpdateCompany = (data) => {
    return request({
        url: '/Basic/UpdateCompany',
        method: 'post',
        data,
        token: Cookies.get('Token')
    })
}

// 删除公司
export const DeleteCompany = (params) => {
    return request({
        url: '/Basic/DeleteCompany' + params,
        method: 'get',
        token: Cookies.get('Token')
    })
}

// 获取公司列表不带分页
export const GetCompanyLists = (params) => {
    return request({
        url: '/Basic/GetCompanyLists' + params,
        method: 'get',
        token: Cookies.get('Token')
    })
}

// 获取部门列表(带分页)
export const GetDepartmentList = (params) => {
    return request({
        url: '/Basic/GetDepartmentList' + params,
        method: 'get',
        token: Cookies.get('Token')
    })
}

// 添加部门
export const AddDepartment = (data) => {
    return request({
        url: '/Basic/AddDepartment',
        method: 'post',
        data,
        token: Cookies.get('Token')
    })
}

// 修改部门
export const UpdateDepartment = (data) => {
    return request({
        url: '/Basic/UpdateDepartment',
        method: 'post',
        data,
        token: Cookies.get('Token')
    })
}

// 删除部门
export const DeleteDepartment = (params) => {
    return request({
        url: '/Basic/DeleteDepartment' + params,
        method: 'get',
        token: Cookies.get('Token')
    })
}

// 获取部门列表（不带分页）
export const GetDepartmentLists = (params) => {
    return request({
        url: '/Basic/GetDepartmentLists' + params,
        method: 'get',
        token: Cookies.get('Token')
    })
}

// 加载所有用户
export const LoaderUserList = (params) => {
    return request({
        url: '/User/LoaderUserList' + params,
        method: 'get',
        token: Cookies.get('Token')
    })
}

// 添加用户
export const AddUser = (data) => {
    return request({
        url: '/User/AddUser',
        method: 'post',
        data,
        token: Cookies.get('Token')
    })
}

// 添加用户
export const UpdateUser = (data) => {
    return request({
        url: '/User/UpdateUser',
        method: 'post',
        data,
        token: Cookies.get('Token')
    })
}

// 删除用户
export const DeleteUser = (params) => {
    return request({
        url: '/User/DeleteUser' + params,
        method: 'post',
        token: Cookies.get('Token')
    })
}

// 绑定系统账号接口
export const BindSystemAccount = (data) => {
    return request({
        url: '/Sso/BindSystemAccount',
        method: 'post',
        data,
        token: Cookies.get('Token')
    })
}

// 获取系统绑定的账号列表
export const GetSysUserSystemModels = (params) => {
    return request({
        url: '/Sso/GetSysUserSystemModels' + params,
        method: 'get',
        token: Cookies.get('Token')
    })
}

// 解绑账号
export const UnBindSystemAccount = (params) => {
    return request({
        url: '/Sso/UnBindSystemAccount' + params,
        method: 'get',
        token: Cookies.get('Token')
    })
}

// 登录业务系统
export const LoginSso = (params) => {
    return request({
        url: '/Sso/LoginSso' + params,
        method: 'get',
        token: Cookies.get('Token')
    })
}